import { Container, Item } from 'Components/Grid';
import HistoryRowBasicItem from 'Components/HistoryRowBasicItem';
import { isPartialDate } from 'neuro-utils';
import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import { formatPartialDate } from 'Utility/date';

const PeriodWithoutMedicationHistoryRowData = ({ document }: IOwnProps): React.JSX.Element => {
  const locPath = 'medication.periodWithoutMedication';

  return (
    <Container>
      <Item xs={2}>
        <HistoryRowBasicItem
          header={<FormattedMessage id={locPath + '.date'} />}
          value={
            !isPartialDate(document.endDate) ? (
              <FormattedMessage
                id="medication.startingDate"
                values={{
                  date: `${formatPartialDate(document.startDate)}`,
                }}
              />
            ) : (
              `${formatPartialDate(document.startDate)}` + ' - ' + `${formatPartialDate(document.endDate)}`
            )
          }
        />
      </Item>
      <Item xs={3}>
        <HistoryRowBasicItem
          header={<FormattedMessage id={locPath + '.reason'} />}
          value={document.reason && <FormattedMessage id={locPath + '.opts.' + document.reason} />}
        />
      </Item>
      {document.reason === 'other' && (
        <Item xs={7}>
          <HistoryRowBasicItem
            header={<FormattedMessage id={locPath + '.reasonOther'} />}
            value={document.reasonOther}
          />
        </Item>
      )}
    </Container>
  );
};

interface IOwnProps {
  document: IDocumentWithTypeV2<'periodWithoutMedication'>;
}

export default PeriodWithoutMedicationHistoryRowData;
